import { Component, Input, OnInit } from '@angular/core';

import { GetQueuesStatisticsDto } from 'src/app/core/api/models/get-queues-statistics-dto';
import { LoggerService } from 'src/app/core/services/logger.service';
import { TranslationService } from 'src/app/i18n';

@Component({
    selector: 'app-queues-statistics-card',
    templateUrl: './queues-statistics-card.component.html',
    styleUrls: ['./queues-statistics-card.component.scss'],
    standalone: false
})
export class QueuesStatisticsCardComponent implements OnInit {

  @Input() model: GetQueuesStatisticsDto;
  @Input() vocabsPath: string;

  constructor(
    protected loggerService: LoggerService,
    public translationService: TranslationService
  ) {}

  ngOnInit(): void {}
}
